import React, { Fragment } from 'react';
import { translate } from '../../Services/translation';

const ProductSpecification = ({ specification }) => {
  const getRowValue = (value) => {
    if (value == 'True') {
      return translate('global.yes');
    }
    if (value == 'False') {
      return translate('global.no');
    } else {
      return value;
    }
  };
  return (
    <div className="product-specifications__specification">
      {specification.map((row) => (
        <Fragment key={row.name + row.value}>
          {row.value && (
            <div className="product-specifications__specification--row">
              <span className="bold">{row.name}</span>
              <span>{getRowValue(row.value)}</span>
            </div>
          )}
        </Fragment>
      ))}
    </div>
  );
};

export default ProductSpecification;
